var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.25 11.789v-8.4L4.785 5.853 3.73 4.769 8 .5l4.27 4.27-1.055 1.084L8.75 3.388v8.4zM2.308 17.5q-.758 0-1.283-.525A1.75 1.75 0 0 1 .5 15.692V9.981H2v5.711q0 .116.096.212a.3.3 0 0 0 .212.096h11.384a.3.3 0 0 0 .212-.096.3.3 0 0 0 .096-.212V9.981h1.5v5.711q0 .758-.525 1.283t-1.283.525z"
  })));
};
export default SvgShare;